import { Injectable } from '@angular/core';
import { AjaxService } from '../../../services/ajax.service';
import { ViewScopeService } from '../../../services/view-scope.service';
import { Observable, of } from 'rxjs';
import { tap, map, catchError } from 'rxjs/operators';

import { MOVEIN_HIST, MOVEIN_DATA } from '../../../services/account-api.constants';
import { MoveinExportHistory, MoveinExtendedData } from '../../../models/movein-export-hist.model';

@Injectable({
	providedIn: 'root'
})
export class MoveinHistoryService {
	constructor(private ajaxService: AjaxService, private viewScopeService: ViewScopeService)
	{ }

	public getMoveinExportHistory() {

		const apiUrl = this.ajaxService.getBaseOfApi() + MOVEIN_HIST + '/' + this.viewScopeService.getCurrentCustomer() + '/'+ this.viewScopeService.getSelectedCompanyId() + '/' + this.viewScopeService.getCurrentOpertaingUserId();

		return this.ajaxService.getData(apiUrl).pipe(
			map((apiResponse: any) => {
				const arr = apiResponse as any[];
				return arr.map(item => ({
					MoveIn_ExportRecID: item.MoveIn_ExportRecID,
					DoseRecID: item.DoseRecID,
					Dose: item.Dose,
					filePath: item.filePath,
					LastMoveINFilePath: item.LastMoveINFilePath,
					Url: item.Url, // Actually the one that will be shown in the screen.
					MoveInCreateDate: item.MoveInCreateDate,
					UserName: item.UserName,
					RoleName: item.RoleName,
					IsTmpMoveIn: item.IsTmpMoveIn
				})) as MoveinExportHistory[];
			}));
	}


	public getMoveinAdditionalData(doseRecID : number)
	{
		const apiUrl = this.ajaxService.getBaseOfApi() + MOVEIN_DATA + this.viewScopeService.getCurrentCustomer() + '/'+ doseRecID + '/' + this.viewScopeService.getCurrentOpertaingUserId();

		return this.ajaxService.getData(apiUrl).pipe(
			map((apiResponse: any) => {
				const arr = apiResponse as any[];
				return arr.map(item => ({
					MoveInLinesRecID : item.MoveInLinesRecID,
					FileRecID : item.FileRecID,
					JornalID : item.JornalID,
					DoseRecID : item.DoseRecID,
					LineNumber : item.LineNumber,
					Descr : item.Descr,
					DateEntered : item.DateEntered,
					Line : item.Line ?? item.line
				})) as MoveinExtendedData[];
			}));
	}
}
